import React from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumb as BootstrapBreadcrumb } from 'react-bootstrap';

const Breadcrumb = ({ items }) => {
  return (
    <div className="d-sm-flex align-items-center justify-content-between mb-4">
      <BootstrapBreadcrumb className="mb-0">
        {items.map((item, index) => (
          <BootstrapBreadcrumb.Item 
            key={index}
            active={index === items.length - 1}
            linkAs={item.href ? Link : 'span'}
            linkProps={item.href ? { to: item.href } : {}}
          >
            {item.icon && <i className={`${item.icon} me-1`}></i>}
            {item.label}
          </BootstrapBreadcrumb.Item>
        ))}
      </BootstrapBreadcrumb>
    </div>
  );
};

export default Breadcrumb;